/*
 * Created on Tue Jun 15 2021
 *
 * Copyright (c) 2021 Khor Chai Hong
 */


import { Link } from "react-router-dom";
import { useWindowDimensions } from "./utils/helpers";

export function Footer({ displayAll, className }) {
    let currentYear = new Date().getFullYear();
    const { windowWidth } = useWindowDimensions();
    return (
        <div id="footer" className={"subpixel " + (displayAll ? '' : 'd-none') + (className ? className : '')}>
            <span>Copyright © {currentYear} <b>Groundcrew Pte. Ltd.</b> All Rights Reserved.</span>
            {windowWidth < 1030 ? <br /> : null}
            <Link className="footer-link" target="_blank" to="/here/privacy">Privacy Policy</Link>
            <span>|</span>
            <Link className="footer-link" target="_blank" to="/here/terms">Terms of Use</Link>
            <span>|</span>
            <Link className="footer-link" target="_blank" to="/here/contact-us">Contact Us</Link>
        </div>
    )
}

export function MenuFooter() {
    return (
        <div id="menuFooter" className="pn">
            <Link className="footer-link" target="_blank" to="/here/manifesto">About <span className="pn-bold">itch</span></Link>
            <span>|</span>
            <Link className="footer-link" target="_blank" to="/faq">FAQ</Link>
            <span>|</span>
            <Link className="footer-link" target="_blank" to="/here/privacy">Privacy & Terms</Link>
            <span>|</span>
            <Link className="footer-link" target="_blank" to="/here/contact-us">Contact Us</Link>
        </div>
    )
}
